<template>
  <v-container fluid>
    <v-card v-if="product" class="mx-auto my-4" max-width="1200">
      <v-row no-gutters>
        <!-- Product Image -->
        <v-col cols="12" md="6" class="d-flex flex-column">
          <v-carousel
            v-if="product.medias.length"
            hide-delimiters
            delimiter-icon="mdi-square"
            show-arrows="hover"
            cycle
            height="auto"
          >
            <v-carousel-item
              v-for="(media, index) in sortedMedias"
              :key="index"
              :src="getImageUrl(media)"
              height="100%"
              width="100%"
              :alt="`${product.product_name} - Gambar ${index + 1}`"
            ></v-carousel-item>
          </v-carousel>
          <v-img
            v-else
            :src="getMainImageUrl(product.medias)"
            :alt="product.product_name"
            height="auto"
            width="100%"
            contain
          ></v-img>

          <!-- VIDEO PRODUK (Google Drive) -->
<v-card v-if="driveFileId" class="mt-4" outlined>
  <v-card-title class="text-subtitle-1 font-weight-bold">
    Video Produk
  </v-card-title>
  <v-card-text>
    <div class="video-wrapper">
      <iframe
        :src="driveEmbedUrl"
        allow="autoplay; fullscreen"
        allowfullscreen
        loading="lazy"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </div>
  </v-card-text>
</v-card>

        </v-col>

        <!-- Product Details Column -->
        <v-col cols="12" md="6" class="pa-4">
          <!-- Product Name -->
          <v-card-item class="pa-0">
            <div class="pt-2 pb-1">
              <h1 class="product-title text-h5 font-weight-bold">
                {{ product.product_name }}
              </h1>
              <div class="product-price text-primary text-h5 font-weight-bold">
                {{ product.price_display }}
              </div>
            </div>
          </v-card-item>

          <v-divider class="my-3"></v-divider>
<h4 class="mb-2 font-semibold">Deskripsi</h4>
<div class="relative">
  <p class="text-body-2 text-grey-darken-1" style="white-space: pre-line;">
    {{ product.description || '-' }}
  </p>
  <!-- Overlay -->
  <div class="no-copy-overlay"></div>
</div>

<h4 class="mt-4 mb-2 font-semibold">Spesifikasi</h4>
<div class="relative">
  <p class="text-body-2 text-grey-darken-1" style="white-space: pre-line;">
    {{ product.specification || 'Tidak ada spesifikasi.' }}
  </p>
  <!-- Overlay -->
  <div class="no-copy-overlay"></div>
</div>



          <!-- Additional Details -->
          <v-row dense class="mt-4">
  <v-col cols="6">
    <v-card class="pa-3 text-center" outlined>
      <div class="text-caption text-grey">Stok</div>
      <div class="text-subtitle-1 font-weight-bold">
        {{ product.product_qty }}
      </div>
    </v-card>
  </v-col>
  <v-col cols="6">
    <v-card class="pa-3 text-center" outlined>
      <div class="text-caption text-grey">Berat</div>
      <div class="text-subtitle-1 font-weight-bold">
        {{ product.product_weight }} gr
      </div>
    </v-card>
  </v-col>
</v-row>


          <!-- <v-divider class="my-4"></v-divider>
          <v-expansion-panels>
            <v-expansion-panel >
              <v-expansion-panel-title>Variasi </v-expansion-panel-title>
              <v-expansion-panel-text v-for="(variation, index) in product.variations" :key="variation.id">
                  <v-card-subtitle>
                    <p><strong>Variasi:</strong> {{ variation.variation_name }}</p>
                    <p><strong>Kode Item:</strong> {{ variation.item_code }}</p>
                    <p><strong>Price:</strong> Rp {{ numeralFormat(variation.variation_price, "0,[]00") }}</p>
                    <p class="mb-2"><strong>Quantity:</strong> {{ variation.variation_qty }}</p>
                  </v-card-subtitle>
                  <v-divider></v-divider>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels> -->

<template v-if="product.variations?.length">
  <v-divider class="my-4"></v-divider>

  <h4 class="mb-2 font-semibold">Variasi Produk</h4>
  <v-row dense>
  <v-col
    v-for="variation in product.variations"
    :key="variation.variation_id"
    cols="12"
    sm="6"
    md="4"
  >
    <v-card
      class="pa-3 cursor-pointer hover:shadow-lg transition-all"
      outlined
    >
      <div class="d-flex flex-column">
        <span class="text-subtitle-1 font-weight-bold">
          {{ variation.variation_name }}
        </span>
        <span class="text-body-2 text-grey">
          Kode: {{ variation.item_code || '-' }}
        </span>
        <span class="text-body-1 mt-1">
          Rp {{ numeralFormat(variation.variation_price, "0,0") }}
        </span>
        <span class="text-caption mt-1">
          Stok: {{ variation.variation_qty }}
        </span>
      </div>
    </v-card>
  </v-col>
</v-row>
</template>


          <!-- Product Variations -->
          

         <v-card-actions class="flex-column">
  <v-btn
  v-if="waLink"
  :href="waLink"
  target="_blank"
  rel="noopener"
  rounded="lg"
  variant="flat"
  block
  color="#25D366"
>
  <v-icon start>mdi-whatsapp</v-icon>
  Tanya produk ini
</v-btn>

<v-btn
  v-if="product.shopee_link"
  :href="product.shopee_link"
  target="_blank"
  rel="noopener"
  rounded="lg"
  variant="tonal"
  block
  class="mt-2 ms-0"
  color="#EE4D2D"
>
  <v-icon start>mdi-storefront</v-icon>
  Beli di Shopee
</v-btn>

<v-btn
  rounded="lg"
  variant="text"
  block
  class="mt-2 ms-0"
  color="primary"
  size="small"
  @click="goBack"
>
  <v-icon start>mdi-arrow-left</v-icon>
  Kembali
</v-btn>
</v-card-actions>
        </v-col>
      </v-row>
    </v-card>
<div v-else-if="error" class="text-center py-16">
  <v-icon size="64" color="grey-lighten-1">mdi-package-variant-closed-remove</v-icon>
  <div class="text-h6 mt-4">Produk tidak ditemukan</div>
  <div class="text-body-2 text-grey mt-1">
    Produk mungkin sudah tidak tersedia atau tautannya salah.
  </div>
  <v-btn color="primary" rounded="xl" class="mt-6" @click="goBack">
    <v-icon start>mdi-arrow-left</v-icon>
    Kembali
  </v-btn>
</div>
    <v-card v-else class="mx-auto my-4" max-width="1200">
  <v-row no-gutters>
    <v-col cols="12" md="6" class="pa-4">
      <v-skeleton-loader type="image" height="400"></v-skeleton-loader>
    </v-col>

    <v-col cols="12" md="6" class="pa-4">
      <v-skeleton-loader type="heading" class="mb-2"></v-skeleton-loader>
      <v-skeleton-loader type="text" width="40%" class="mb-4"></v-skeleton-loader>
      <v-divider class="my-3"></v-divider>
      <v-skeleton-loader type="paragraph" class="mb-4"></v-skeleton-loader>
      <v-skeleton-loader type="paragraph" class="mb-4"></v-skeleton-loader>
      <v-row dense>
        <v-col cols="6"><v-skeleton-loader type="card"></v-skeleton-loader></v-col>
        <v-col cols="6"><v-skeleton-loader type="card"></v-skeleton-loader></v-col>
      </v-row>
      <v-skeleton-loader type="button" class="mt-4"></v-skeleton-loader>
    </v-col>
  </v-row>
</v-card>
  </v-container>
</template>

<script>
import numeral from 'numeral'

export default {
  data() {
    return {
      product: null,
      error: false,
      contacts: null,
    };
  },
  async mounted() {
    const { id } = this.$route.params;
    try {
      const response = await this.$axios.get(`/product/${id}`);
      this.product = response.data.data;
      this.applySeo(this.product);
      this.injectStructuredData(this.product);
    } catch (error) {
      console.error('Error fetching product details:', error);
      this.product = null;
      this.error = true
    }

    try {
      const res = await this.$axios.get('/contact');
      this.contacts = res.data.data;
    } catch (e) {
      console.error('Error fetching contact:', e);
    }
  },
  computed:{
    waLink() {
      const phone = this.contacts?.phone_1;
      if (!phone || !this.product) return null;

      const nomor = String(phone).replace(/\D/g, '').replace(/^0/, '62');

      const pesan =
        `Halo GP21SHOP, saya ingin bertanya tentang produk ini:\n\n` +
        `*${this.product.product_name}*\n` +
        `${this.product.price_display || ''}\n` +
        `${window.location.href}\n\n` +
        `Pertanyaan saya: `;

      return `https://wa.me/${nomor}?text=${encodeURIComponent(pesan)}`;
    },
    sortedMedias() {
      return this.product?.medias
        ? [...this.product.medias].sort((a, b) => a.display_order - b.display_order)
        : [];
    },
    // NEW
  driveFileId() {
    const link = this.product?.google_drive_link;
    if (!link) return null;
    return this.extractDriveFileId(link);
  },
  // NEW
  driveEmbedUrl() {
    return this.driveFileId
      ? `https://drive.google.com/file/d/${this.driveFileId}/preview`
      : null;
  },
  
  },
  methods: {
    setMeta(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
},

setCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
},

applySeo(p) {
  const sub = p.subcategory?.subcategory || '';
const judul = `${p.product_name}${sub ? ' - ' + sub : ''} | GP21SHOP`;
  const desk = (p.description || '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 155);

  document.title = judul;
  this.setMeta('description', desk);
  this.setCanonical(window.location.href);

  this.setMeta('og:title', judul, true);
  this.setMeta('og:description', desk, true);
  this.setMeta('og:image', this.getMainImageUrl(p.medias), true);
  this.setMeta('og:url', window.location.href, true);
  this.setMeta('og:type', 'product', true);
  
},
     extractDriveFileId(url) {
    if (!url) return null;
    const patterns = [
      /\/file\/d\/([a-zA-Z0-9_-]{10,})/i, // .../file/d/ID/...
      /[?&]id=([a-zA-Z0-9_-]{10,})/i,     // ...?id=ID
      /\/uc\?id=([a-zA-Z0-9_-]{10,})/i,   // .../uc?id=ID
    ];
    for (const re of patterns) {
      const m = url.match(re);
      if (m && m[1]) return m[1];
    }
    return null;
  },
    getImageUrl(media) {
      const baseUrl = `${this.$urlImage}storage/images/`;
      const defaultImageUrl = 'https://via.placeholder.com/300';
      return media.media && media.media.media_name ? `${baseUrl}${media.media.media_name}` : defaultImageUrl;
    },
    getMainImageUrl(medias) {
      const media = medias.find(m => m.media && m.media.media_name);
      const baseUrl = `${this.$urlImage}storage/images/`
      const defaultImageUrl = 'https://via.placeholder.com/300';
      return media && media.media.media_name ? `${baseUrl}${media.media.media_name}` : defaultImageUrl;
    },
    numeralFormat(value, format) {
      return numeral(value).format(format); // Use numeral for formatting
    },
    goBack() {
      this.$router.back();
    },
    injectStructuredData(product) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": product.product_name,
  "image": this.getMainImageUrl(product.medias),
  "description": product.description,
  "sku": product.item_code || product.product_id,
  "brand": {
    "@type": "Brand",
    "name": product.subcategory?.subcategory || "GP21SHOP"
  }
});
    document.head.appendChild(script);
  }
  }
};
</script>

<style scoped>
.v-alert {
  border-radius: 4px;
  padding: 16px;
}

/* <style scoped> tambah ini */
.relative { position: relative; }

/* Overlay transparan untuk menahan seleksi/copy/long-press */
.no-copy-overlay {
  position: absolute;
  inset: 0;
  pointer-events: auto;      /* blokir drag/select */
  -webkit-touch-callout: none; /* iOS: tahan lama */
}
  .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relative {
  position: relative;
}

.no-copy-overlay {
  position: absolute;
  inset: 0;                   /* full cover */
  background: transparent;     /* transparan */
  pointer-events: auto;        /* tangkap semua interaksi */
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none; /* iOS long press menu */
}

/* 16:9 wrapper untuk iframe */
.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  border-radius: 12px;
}
.video-wrapper > iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}


</style>
